import React from 'react';
import Modal from 'react-bootstrap/Modal';

const CompanyStatusModal = ({ show, type, onClose }) => {
  const getModalContent = () => {
    switch (type) {
      case 'profile_incomplete':
        return {
          title: '',
          message: 'Service temporarily unavailable. Please try again later.',
          buttonText: 'Complete Profile',
          buttonColor: '#2c58ab'
        };
      case 'trial_expired':
        return {
          title: '',
          message: 'Service temporarily unavailable. Please try again later.',
          buttonText: 'Purchase Subscription',
          buttonColor: '#2c58ab'
        };
      case 'subscription_expired':
        return {
          title: '',
          message: 'Service temporarily unavailable. Please try again later.',
          buttonText: 'Renew Subscription',
          buttonColor: '#2c58ab'
        };
      default:
        return {
          title: 'Action Required',
          message: 'Please complete the required action to continue.',
          buttonText: 'OK',
          buttonColor: '#2c58ab'
        };
    }
  };

  const content = getModalContent();

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton={false}>
        <Modal.Title style={{ color: '#23235b', fontWeight: 'bold' }}>
          {content.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{fontSize: '16px', textAlign: 'center'}}>
          {content.message}
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default CompanyStatusModal;
